(function () {
    function BrowserChecker() {

    }

    BrowserChecker.prototype.getBrowserInfo = function () {
        var Msie = /(msie\s|trident.*rv:)([\w.]+)/;
        var Firefox = /(firefox)\/([\w.]+)/;
        var Chrome = /(chrome)\/([\w.]+)/;
        var ChromeOnIos = /(crios)\/([\w.]+)/;
        var Opera = /(opera).+version\/([\w.]+)/;
        var Safari = /version\/([\w.]+).*(safari)/;
        var WebView = /(applewebkit)\/([\w.]+)/;
        var browser;
        var version;
        var agent = navigator.userAgent.toLowerCase();
        var match = Msie.exec(agent);
        if (null != match) {
            return {
                browser: "IE",
                version: match[2] || "0"
            };
        }
        var match = Firefox.exec(agent);
        if (null != match) {
            return {
                browser: match[1] || "",
                version: match[2] || "0"
            };
        }
        var match = Chrome.exec(agent);
        if (null != match) {
            return {
                browser: match[1] || "",
                version: match[2] || "0"
            };
        }
        var match = ChromeOnIos.exec(agent);
        if (null != match) {
            return {
                browser: match[1] || "",
                version: match[2] || "0"
            };
        }
        var match = Opera.exec(agent);
        if (null != match) {
            return {
                browser: match[1] || "",
                version: match[2] || "0"
            };
        }
        var match = Safari.exec(agent);
        if (null != match) {
            return {
                browser: match[2] || "",
                version: match[1] || "0"
            };
        }
        var match = WebView.exec(agent);
        if (null != match) {
            return {
                browser: match[1] || "",
                version: match[2] || "0"
            };
        }
        return "false";
    };

    BrowserChecker.prototype.getIEMinVersion = function () {
        return 9;
    };

    BrowserChecker.prototype.getChromeMinVersion = function () {
        return 31;
    };

    BrowserChecker.prototype.getFirefoxMinVersion = function () {
        return 27;
    };

    BrowserChecker.prototype.getSafariMinVersion = function() {
        return 5;
    }

    BrowserChecker.prototype.getIEMinVersion4HEC = function () {
        return 8;
    };

    BrowserChecker.prototype.getWebViewMinVersion = function () {
        return 500;
    };

    BrowserChecker.prototype.isSupport = function () {
        var supportedBrowserVersion = "IE:" + this.getIEMinVersion() + ";firefox:" + this.getFirefoxMinVersion() + ";chrome:" + this.getChromeMinVersion() + ";crios:" + this.getChromeMinVersion() + ";Safari:" + this.getSafariMinVersion() + ";applewebkit:" + this.getWebViewMinVersion();
        return isSupport(supportedBrowserVersion);
    };

    BrowserChecker.prototype.isSupport4HEC = function () {
        var supportedBrowserVersion = "IE:" + this.getIEMinVersion4HEC() + ";firefox:" + this.getFirefoxMinVersion() + ";chrome:" + this.getChromeMinVersion() + ";crios:" + this.getChromeMinVersion() + ";Safari:" + this.getSafariMinVersion() + ";applewebkit:" + this.getWebViewMinVersion();
        return isSupport(supportedBrowserVersion);
    };

    function isSupport(supportedBrowserVersion) {
        var currentInfo = BrowserChecker.prototype.getBrowserInfo();
        if ("false" == currentInfo) {
            return false;
        }
        var supportarray = supportedBrowserVersion.toLowerCase().split(';');
        var browser = currentInfo.browser.toLowerCase();
        var version = currentInfo.version;
        var flag = true;
        for (var i = 0; i < supportarray.length; i++) {
            var supportInfo = supportarray[i].split(":");
            // supportInfo[0]获取支持浏览器类型,supportInfo[1]获取支持浏览器版本号
            if (-1 != browser.indexOf(supportInfo[0])) {
                flag = false;
                //使用的浏览器是否属于支持的信息标记
                var ver = supportInfo[1].split(",");
                // ver[0]为最低版本，ver[1]为最高版本
                if (ver.length == 2) {
                    if (parseFloat(version) < parseFloat(ver[0]) || parseFloat(version) > parseFloat(ver[1])) {
                        return false;
                    }
                } else if (ver.length == 1) {
                    if (parseFloat(version) < parseFloat(ver[0])) {
                        return false;
                    }
                }
            }
        }
        if (flag) {
            //flag的值不改变，则使用的浏览器不在支持的范围中
            return false;
        }
        return true;
    }

    function getConsoleType () {
        //此处需要通过升级脚本来替换域名与样式的对应关系，兼容IE8
        var consoleMap = {authDomain:"styleMap"};

        //除TLF外没有升级脚本进行样式域名对应关系替换，直接返回空串“”
        if (consoleMap['authDomain'] === "styleMap"){
            return ""
        }
        for (var name in consoleMap){
            if (name && consoleMap[name] && name === location.host){
                return consoleMap[name];
            }
        }
        return "vivo";
    };

    BrowserChecker.prototype.redirect = function (defaultLanguage) {
        var language = window.language ? window.language : defaultLanguage;
        var consoleType = getConsoleType();
        if(consoleType)
        {
            window.location.href = "/authui/public/custom/browserSupport_" + consoleType + "_" + language + ".html";
        }else
        {
            window.location.href = "/authui/public/custom/browserSupport_" + language + ".html";
        }
    };

    if (!window.IAM) {
        window.IAM = {};
    }
    window.IAM.BrowserChecker = BrowserChecker;
})();


// WEBPACK FOOTER //
// ./public/base/pre/browserChecker.js